import {
  createContext,
  useContext,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";
import { UseFormReturn } from "react-hook-form";
import {
  FormStep,
  ListingFormValues,
} from "@/components/listings/filters/FilterSchema";

interface ListingFormContextType {
  form: UseFormReturn<ListingFormValues>;
  currentStep: FormStep;
  setCurrentStep: Dispatch<SetStateAction<FormStep>>;
  isSubmitting: boolean;
  setIsSubmitting: (isSubmitting: boolean) => void;
  completedSteps: Record<number, boolean>;
  setStepCompleted: (step: FormStep, isCompleted: boolean) => void;
  canProceedToNextStep: boolean;
  setCanProceedToNextStep: (canProceed: boolean) => void;
  completionPercentage: number;
  formTouched: boolean;
  validateOnChange: boolean;
  setValidateOnChange: Dispatch<SetStateAction<boolean>>;
  clearAllListingData: () => void; // Add this line
}

const ListingFormContext = createContext<ListingFormContextType | undefined>(
  undefined
);

export function useListingFormContext() {
  const context = useContext(ListingFormContext);
  if (context === undefined) {
    throw new Error(
      "useListingFormContext must be used within a ListingFormProvider"
    );
  }
  return context;
}

interface ListingFormProviderProps {
  children: ReactNode;
  value: ListingFormContextType;
}

export function ListingFormProvider({
  children,
  value,
}: ListingFormProviderProps) {
  return (
    <ListingFormContext.Provider value={value}>
      {children}
    </ListingFormContext.Provider>
  );
}
